// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, ".wrapper[data-v-2977efbe]{position:relative;z-index:0}.wrapper .clickLayer[data-v-2977efbe]{opacity:0;position:absolute;z-index:1;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.15);transition:opacity .3s ease-in-out;cursor:pointer}.wrapper .clickLayer[data-v-2977efbe]:hover{opacity:1}", ""]);
// Exports
module.exports = exports;
